/**
 * Vue Router configuration for The Ephemera Archive
 */

import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/MainView.vue'),
  },
  {
    path: '/your-visit',
    name: 'your-visit',
    component: () => import('../views/YourVisitView.vue'),
  },
  {
    path: '/wing/:wingId',
    name: 'wing',
    component: () => import('../views/WingView.vue'),
    props: true,
  },
  {
    path: '/achievements',
    name: 'achievements',
    component: () => import('../views/AchievementsView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0, behavior: 'smooth' };
  },
});

export default router;
